import { apiAsync } from '../../../../common/helpers'

const queryShipments = async (props) => {

  const params = {
    pageNumber: props.pageNumber,
    ...props.sortOptions.field && { sortByField: props.sortOptions.field },
    ...props.sortOptions.direction && { sortDirection: props.sortOptions.direction },
    ...props.filters.state && { 'filter~shipment_address_states': props.filters.state.locale.state },
    ...props.filterOptions.hasOwnProperty('filter~posterCheck_status') &&
            props.filterOptions['filter~posterCheck_status'].filter !== undefined &&
            { 'filter~posterCheck_status': props.filterOptions['filter~posterCheck_status'].filter },
    ...props.searchText && { searchText: props.searchText },
    pageSize: props.rowsPerPage
  }

  const endpointToken = props.getCsv ? "csv" : "search"

  return await apiAsync({
    api: `companies/${(props.companyId)}/${(props.recordType)}/${endpointToken}`,
    params,
    method: 'GET',
  })
}


export default queryShipments
